import {
  Box,
  chakra,
  Container,
  Stack,
  Text,
  VisuallyHidden,
} from '@chakra-ui/react';
import { FaFacebook, FaLinkedin } from 'react-icons/fa';
import { ReactNode } from 'react';

const SocialButton = ({
  children,
  label,
  href,
}: {
  children: ReactNode;
  label: string;
  href: string;
}) => {
  return (
    <chakra.button
      bg="sage.50"
      color="sage.600"
      rounded="full"
      w={9}
      h={9}
      cursor="pointer"
      as="a"
      target="_blank"
      href={href}
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      transition="all 0.2s ease"
      _hover={{ bg: "sage.100", color: "sage.700" }}
    >
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};

const Footer = () => {
  const date = new Date();
  return (
    <Box
      borderTopWidth="1px"
      borderTopColor="sage.100"
      bg="white"
    >
      <Container
        as={Stack}
        py={5}
        textAlign="center"
        fontSize="sm"
        color="gray.500"
        w={["90%", "85%", "80%"]}
        maxW={960}
        mx="auto"
        direction={{ base: 'column', md: 'row' }}
        spacing={4}
        justify={{ base: 'center', md: 'space-between' }}
        align="center"
      >
        <Text fontFamily="body">
          © {date.getFullYear()} Psicóloga Beatriz Sifuentes
        </Text>
        <Stack direction="row" spacing={3}>
          <SocialButton label="LinkedIn" href="https://www.linkedin.com/in/beatriz-sifuentes-capu%C3%B1ay-9706b339/">
            <FaLinkedin size={16} />
          </SocialButton>
          <SocialButton label="Facebook" href="https://www.facebook.com/Psicologabeatrizsifuentess">
            <FaFacebook size={16} />
          </SocialButton>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
